import { css } from "@emotion/react";
import type { ReactNode } from "react";

import Spacer from "../space/Spacer";
import Text from "../Text";

type PageHeaderProps = {
    title: string;
    action?: ReactNode;
};
export default function PageHeader(props: PageHeaderProps) {
    const { title, action } = props;

    const contentCss = css({
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
    });

    return (
        <div>
            <div css={contentCss}>
                <Text variant="heading">{title}</Text>
                <Spacer scale={4} fill />
                {action}
            </div>
            <Spacer scale={4} />
        </div>
    );
}
